module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoice_not_found":"Invoice not found or empty"}}')
  delete Component.options._Ctor
}
